import { Component, Input, NgZone, ChangeDetectorRef, ElementRef, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';

import { VisualStateService } from "@common/services/visual-state-service";
import { GlobalTablesService } from '@common/services/global-tables-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { LanguageSettings } from '@common/services/language-settings';
import { MatSelectionListChange } from '@angular/material/list';
import { Record } from "@common/data-models/records/record";
import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    selector: 'topic-type',
    templateUrl: './topic-type.html',
    styleUrls: ['./topic-type.scss'],
    host: {
        class: 'st-topic-type'
    },
    encapsulation: ViewEncapsulation.None
})
export class TopicType extends EnpsControl<Array<string>> {
    public readonly noTypeItem: string = 'PSTWebListValue_PSTTopicType_NoType';
    itemsToShow: Array<string> = [];

    @Input() public itemList: Array<{ id: string, title: string }> = [];

    @Input() labelTranslationPrefix: string = '';
    @Input() record: Record;
    private _showAdd = false;
    @Input()
    get showAdd() {
        return this._showAdd;
    }
    set showAdd(value: BooleanInput) {
        this._showAdd = coerceBooleanProperty(value);
    }

    private _maxValuesToShow = 2;
    @Input()
    get maxValuesToShow(): number {
        return this._maxValuesToShow
    }
    set maxValuesToShow(value: number) {
        this._maxValuesToShow = value;
        this.itemsToShow = this.value?.slice(0, this.maxValuesToShow) || [];
    }

    @Input()
    get value(): string[] {
        return this._value;
    }
    public set value(v: string[]) {
        this._value = v;
        this._syncValueIfNecessary();
        this.itemsToShow = this.value?.slice(0, this.maxValuesToShow) || [];
    }

    private _showRemove = false;
    @Input()
    get showRemove() {
        return this._showRemove;
    }
    set showRemove(value: BooleanInput) {
        this._showRemove = coerceBooleanProperty(value);
    }

    get maxValuesToShowLabel():string {
        return `+ ${(this.value?.length - this.maxValuesToShow)} more`;
    }

    constructor(
        public appService: AppService,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        public visualStateService: VisualStateService,
        globalTablesService: GlobalTablesService,
        nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        elementRef: ElementRef,
    ) {
        super(appService, ngZone, changeDetectorRef, timeoutQueue, globalTablesService, elementRef);
    }

    public onChange(event) {
        this.changed.emit(event)
    }

    public getItemLabel(item: any) {
        if (item === this.noTypeItem) {
            return this.appService.languageSettings.get(item);
        }
        return this.itemList.find(option => (option.id.toLowerCase().includes(item?.toLowerCase())))?.title;
    }


    internalValueChanged(event: MatSelectionListChange) {
        this.isValueChanged = true;
        this.value = event.source.selectedOptions.selected.map((item) => item.value);
    }

    valueChanged() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this.changed.emit(this.value);
        }
    }

    removeItem(item: string) {
        this.value = this.value.filter((value) => value !== item);
        this.changed.emit(this.value);
    }
}
